import React from 'react';
import PropTypes from 'prop-types';

import './Contacts.css';

const ContactsComponent = ({ contacts = [] }) => {
  const isPrimary = contact => {
    return contact.isPrimary;
  };

  const primaryContact = contacts.find(isPrimary);
  if (primaryContact) {
    const primaryIndex = contacts.indexOf(primaryContact);
    contacts.splice(primaryIndex, 1);
    contacts.unshift(primaryContact);
  }

  return (
    <div>
      {contacts.map((contact, index) => (
        <div className="contacts" key={index}>
          <p>
            <b>{contact.name}</b>
          </p>
          {contact.organization && <p>{contact.organization}</p>}
          {contact.street && <p>{contact.street}</p>}
          {(contact.city && contact.state && contact.zip)
            && <p>{contact.city}, {contact.state} {contact.zip}</p>}
          {contact.phone && <p>{contact.phone}</p>}
          {contact.email && <p><a style={{ color: '#9f0000' }} href={`mailto:${contact.email}`}>{contact.email}</a></p>}
          {contact.webAddr && <p>{contact.webAddr}</p>}
        </div>
      ))}
    </div>
  );
};

ContactsComponent.propTypes = {
  contacts: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
    organization: PropTypes.string,
    street: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    fax: PropTypes.string,
    webAddr: PropTypes.string,
    linkedIn: PropTypes.string,
    isPrimary: PropTypes.bool,
  })),
};

export default ContactsComponent;



// WEBPACK FOOTER //
// ./src/components/Areas/AreaDetails/Contacts.js